<div class="bg-page flex h-full w-full flex-col gap-3 p-4">
  <div class="flex flex-wrap items-baseline gap-3">
    <h1 class="text-text-primary text-xl font-semibold">
      {{ 'topbar.breadcrumb.deploy' | translate }}
    </h1>
    @if (planMetadata(); as plan) {
      <span class="text-text-tertiary font-mono text-xs tabular-nums">{{ plan.id }}</span>
    }
  </div>

  <app-plan-edit-bar class="empty:hidden" [planId]="planId()" />

  <!-- GBE refuses every deploy for a plan in an internal space, so the channel panel's
       Deploy is disabled and this names the remedy. Reading a channel stays available. -->
  @if (deployBlockedByInternal()) {
    <div
      data-testid="deploy-internal-blocked"
      class="bg-warning-soft text-warning flex items-start gap-2 rounded-sm px-3 py-2 text-xs">
      <i [class]="ICONS.eyeSlash" class="mt-0.5"></i>
      <p>{{ 'features.plan.deploy.internal_blocked' | translate }}</p>
    </div>
  }

  @if (isLoadingList()) {
    <div class="flex flex-col gap-2">
      @for (_ of [1, 2, 3]; track $index) {
        <div class="bg-elevated h-14 animate-pulse rounded-sm"></div>
      }
    </div>
  }

  @if (!isLoadingList() && loadError()) {
    <div
      class="bg-danger-soft text-danger flex items-center gap-2 rounded-sm px-3 py-2 text-xs">
      <i [class]="ICONS.warningCircle"></i>
      {{ 'features.plan.deploy.load_error' | translate }}
    </div>
  }

  @if (!isLoadingList() && !loadError() && configs().length === 0) {
    <div
      class="border-default text-text-secondary flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed py-16 text-xs">
      <i [class]="ICONS.paperPlaneTilt" class="text-text-tertiary text-2xl"></i>
      {{ 'features.plan.deploy.empty' | translate }}
    </div>
  }

  @if (!isLoadingList() && !loadError() && configs().length > 0) {
    <div class="flex min-h-0 flex-1 gap-3">
      <aside
        class="bg-surface border-default w-80 shrink-0 overflow-y-auto rounded-lg border">
        <app-deploy-channel-list
          [configs]="configs()"
          [selectedId]="selectedConfigId()"
          [statusByConfigId]="deployStatusByConfigId()"
          [statsByConfigId]="deployStatsByConfigId()"
          (selectConfig)="selectConfig($event)" />
      </aside>

      <section
        class="bg-surface border-default min-w-0 flex-1 overflow-hidden rounded-lg border">
        @if (selectedConfig(); as config) {
          <app-deploy-channel-panel
            [config]="config"
            [planId]="planId()"
            [deployEnabled]="deployAllowed()"
            [lastSentAt]="lastSentAtFor(config.id)"
            [deployStatus]="deployStatusByConfigId().get(config.id) ?? null"
            (deployStarted)="onDeployStarted($event)" />
        } @else {
          <p
            class="text-text-secondary flex h-full items-center justify-center p-6 text-xs">
            {{ 'features.plan.deploy.select_channel' | translate }}
          </p>
        }
      </section>
    </div>
  }
</div>
